
import * as Yup from 'yup'

export const originalData = {
    agreement: [
      { id: 'I', name: 'I = I-avtal (Fastigo / Unionen, Ledarna, AiF).' },
      { id: 'K', name: 'K = K-avtal (Fastigo / Vision, Ledarna, AiF).' },
      { id: 'S', name: 'S = S-avtal (Fastigo / Kommunal).' },
      { id: 'F', name: 'F = F-avtal (Fastigo / Fastighets).' },
      { id: 'M', name: 'M = Månadslöneavtal för målare (Fastigo / Svenska Målareförbundet).' },
      {
        id: 'L',
        name: 'L = Kollektivanställda som går under andra avtal med LO-förbund än S-, F-avtal och Månadslöneavtal för målare.',
      },
      {
        id: 'O',
        name: 'O = Tjänstemän, medarbetare och chefer (inklusive VD) som går under annat avtal än I- och K-avtal.',
      },
    ],
    headProcess: [
      { id: '1', name: '1' },
      { id: '2', name: '2' },
      { id: '3', name: '3' },
      { id: '4', name: '4' },
      { id: '9', name: '9' },
    ],
    subProcess: [
      { id: '1', name: '1' },
      { id: '2', name: '2' },
      { id: '3', name: '3' },
      { id: '4', name: '4' },
      { id: '5', name: '5' },
      { id: '6', name: '6' },
      { id: '9', name: '9' },
    ],
    level: [
      { id: '1', name: '1' },
      { id: '2', name: '2' },
      { id: '3', name: '3' },
      { id: '4', name: '4' },
      { id: '5', name: '5' },
      { id: '6', name: '6' },
      { id: '9', name: '9' },
    ],
    boss: [
      { id: '0', name: 'Ej chef' },
      { id: '9', name: 'Chef' },
    ],
    klassigoSpecial: [
      { id: '0', name: '0' },
      { id: '1', name: '1 = Mer än halva arbetstiden lokalvård' },
      { id: '2', name: '2 = Mer än halva arbetstiden annat än lokalvård.' },
    ],
    employmentForm: [
      {
        id: '1',
        name: '1 = Tillsvidareanställd som arbetat hela eller delar av september (med undantag av de som faller under alternativ 2 och 3 nedan)',
      },
      { id: '2', name: '2 = Tillsvidareanställd som var sjukskriven under hela september' },
      {
        id: '3',
        name: '3 = Tjänstledig eller föräldraledig under hela september, men som ingick i den senaste lönerevisionen',
      },
      { id: '4', name: '4 = Vikarie som ingick i den senaste lönerevisionen' },
      { id: '5', name: '5 = Övrig visstidsanställning' },
    ],
    salaryForm: [
      { id: '1', name: '1 = Månadslön' },
      { id: '2', name: '2 = Veckolön' },
      { id: '3', name: '3 = Timlön' },
    ],
    workAccount: [
      { id: '1', name: '1 = Arbetstidsförkortning' },
      { id: '2', name: '2 = Månadslön' },
      { id: '3', name: '3 = Pensionspremie' },
    ],
  }

  export const fieldsOrder = [
    'personalnumber',
    'name',
    'agreement',
    'klassigoCode',
    'klassigoSpecial',
    'occupationalDesignation',
    'employmentForm',
    'salaryForm',
    'occupationalDesignation',
    'fixedSalary',
    'extraSalary',
    'benefits',
    'resultSalary',
    'weeklyHours',
    'partTimePercentage',
    'workedHours',
    'overTimeHours',
    'overTimeSalary',
    'emergencyCompensation',
    'workAccount',
    'workAccountValue',
    'shorterWorkingHours',
    'vacationDays',
    'otherAdditions',
    'comment',
  ]

 export const emptyStatisticsData = {
    personalnumber: '',
    name: '',
    agreement: '',
    headProcess: '',
    subProcess: '',
    level: '',
    boss: '',
    klassigoCode: '',
    klassigoSpecial: '',
    occupationalDesignation: '',
    employmentForm: '',
    salaryForm: '',
    fixedSalary: '',
    extraSalary: '',
    benefits: '',
    resultSalary: '',
    weeklyHours: '',
    partTimePercentage: '',
    workedHours: '',
    overTimeHours: '',
    overTimeSalary: '',
    emergencyCompensation: '',
    workAccount: '',
    workAccountValue: '',
    shorterWorkingHours: '',
    vacationDays: '',
    otherAdditions: '',
    comment: '',
    valid: false,
    error: '',
    index: 0,
  }
  


  export const validationSchema = (received, scb) => {
  return Yup.object().shape({
    personalnumber: Yup.string()
      .required('Detta fält måste vara ifyllt.')
      .matches(
        /^[0-9]{12}$/,
        'Personnumret har felaktigt format, använd ÅÅÅÅMMDDNNNN utan bindestreck.',
      )
      .validPersonalNumber()
      .singlePersonalnumber(received.data),
    name: Yup.string(),
    agreement: Yup.string()
      .required('Obligatoriskt, information om avtal saknas.')
      .when([], {
        is: () => scb,
        then: Yup.string().oneOf(
          ['I', 'K', 'S', 'F', 'M', 'L', 'O'],
          'Avtal kan endast ha följande tecken: I, K, S, F, M, L, O',
        ),
        otherwise: Yup.string().oneOf(
          ['I', 'K', 'S', 'F', 'M'],
          'Avtal kan endast ha följande tecken: I, K, S, F, M',
        ),
      }),
    klassigoCode: Yup.string()
      .when(['agreement'], {
        is: (agreement) => {
          return scb && (agreement === 'L' || agreement === 'O')
        },
        then: Yup.string(),
        otherwise: Yup.string().required(
          'Obligatoriskt, Klassigo-kod saknas. Vid tveksamhet eller behov av stöd gällande klassificering, kontakta Fastigos statistiker på 08-676 69 23.',
        ),
      })
      .validKlassigo(),
    klassigoSpecial: Yup.string().when(['klassigoCode'], {
      is: (klassigoCode) => {
        return klassigoCode === '2310' || klassigoCode === '2319'
      },
      then: Yup.string().required(
        'Klassigo-special saknas.',
      ),
      otherwise: Yup.string(),
    }),
    occupationalDesignation: Yup.string().required('Obligatoriskt, information om yrkesbeteckning saknas eller är felaktig. Läs anvisningarna och fyll i korrekt värde. Kontakta Fastigos statistiker vid frågor.'),
    employmentForm: Yup.mixed(
      'Obligatoriskt, information om anställningsform saknas eller är felaktig. Läs anvisningarna och fyll i korrekt värde. Kontakta Fastigos statistiker vid frågor.',
    ).when([], {
      is: () => scb,
      then: Yup.number('Obligatoriskt, information om anställningsform saknas eller är felaktig. Läs anvisningarna och fyll i korrekt värde. Kontakta Fastigos statistiker vid frågor.')
        .required('Obligatoriskt, information om anställningsform saknas eller är felaktig. Läs anvisningarna och fyll i korrekt värde. Kontakta Fastigos statistiker vid frågor.')
        .oneOf([1, 2, 3, 4, 5], 'Obligatoriskt, information om anställningsform saknas eller är felaktig. Läs anvisningarna och fyll i korrekt värde. Kontakta Fastigos statistiker vid frågor.'),
    }),
    salaryForm: Yup.mixed('Obligatoriskt, information om löneform saknas eller är felaktig. Läs anvisningarna och fyll i korrekt värde. Kontakta Fastigos statistiker vid frågor.').when([], {
      is: () => scb,
      then: Yup.number('Obligatoriskt, information om löneform saknas eller är felaktig. Läs anvisningarna och fyll i korrekt värde. Kontakta Fastigos statistiker vid frågor.')
        .required('Obligatoriskt, information om löneform saknas eller är felaktig. Läs anvisningarna och fyll i korrekt värde. Kontakta Fastigos statistiker vid frågor.')
        .oneOf([1, 2, 3], 'Obligatoriskt, information om löneform saknas eller är felaktig. Läs anvisningarna och fyll i korrekt värde. Kontakta Fastigos statistiker vid frågor.'),
    }),
    fixedSalary: Yup.number('Obligatoriskt, information om fast månadslön saknas.')
      .min(1, 'Obligatoriskt, information om fast månadslön saknas.')
      .max(400000, 'Lönebeloppet får inte överstiga 400 000 kr.')
      .required('Obligatoriskt, information om fast månadslön saknas.'),
    extraSalary: Yup.number('Endast siffror och kommatecken är tillåtna i detta fält.'),
    benefits: Yup.number('Endast siffror och kommatecken är tillåtna i detta fält.'),
    resultSalary: Yup.number('Endast siffror och kommatecken är tillåtna i detta fält.'),
    weeklyHours: Yup.number()
      .required('Obligatoriskt, information om veckoarbetstid saknas eller är felaktig. Läs anvisningarna och fyll i korrekt värde. Kontakta Fastigos statistiker vid frågor.')
      .min(1, 'Obligatoriskt, information om veckoarbetstid saknas eller är felaktig. Läs anvisningarna och fyll i korrekt värde. Kontakta Fastigos statistiker vid frågor.')
      .max(40, 'Obligatoriskt, information om veckoarbetstid saknas eller är felaktig. Läs anvisningarna och fyll i korrekt värde. Kontakta Fastigos statistiker vid frågor.'),
    partTimePercentage: Yup.number().when(['salaryForm'], {
      is: (salaryForm) => {
        return salaryForm === 3
      },
      then: Yup.number(),
      otherwise: Yup.number()
        .min(1, 'Sysselsättningsgrad måste fyllas i och kan inte vara 0.')
        .max(100, 'Sysselsättningsgrad kan inte överstiga 100,00.')
        .required('Sysselsättningsgrad måste fyllas i och kan inte vara 0.'),
    }),
    workedHours: Yup.number().when([], {
      is: () => scb,
      then: Yup.number('Obligatoriskt, information om arbetad tid saknas eller är felaktig. Läs anvisningarna och fyll i korrekt värde. Kontakta Fastigos statistiker vid frågor.').required(
        'Obligatoriskt, information om arbetad tid saknas eller är felaktig. Läs anvisningarna och fyll i korrekt värde. Kontakta Fastigos statistiker vid frågor.',
      ),
      otherwise: Yup.number(),
    }),
    overTimeHours: Yup.number().when([], {
      is: () => scb,
      then: Yup.number('Endast siffror och kommatecken är tillåtna i detta fält.').max(
        Yup.ref('workedHours'),
        'Värdet kan inte vara större än värdet i fältet Arbetad tid.',
      ),
    }),
    overTimeSalary: Yup.number('Endast siffror och kommatecken är tillåtna i detta fält.'),
    emergencyCompensation: Yup.number('Endast siffror och kommatecken är tillåtna i detta fält.'),
    workAccount: Yup.number('Detta fält får endast ha någon av dessa siffror: 1, 2, 3').oneOf(
      [1, 2, 3],
      'Detta fält får endast ha någon av dessa siffror: 1, 2, 3',
    ),
    workAccountValue: Yup.number('Endast siffror är tillåtna i detta fält.').when(['workAccount'], {
      is: (workAccount) => {
        return workAccount === 3
      },
      then: Yup.number()
        .min(1, 'Detta fält ska vara ifyllt med belopp om Arbetslivskonto - valt alternativ = 3.')
        .required(
          'Detta fält ska vara ifyllt med belopp om Arbetslivskonto - valt alternativ = 3.',
        ),
      otherwise: Yup.number(),
    }),
    shorterWorkingHours: Yup.number().when(['workAccount'], {
      is: (workAccount) => {
        return workAccount === 1
      },
      then: Yup.number('Endast siffror är tillåtna i detta fält.')
        .min(1, 'Detta fält ska vara ifyllt med belopp om Arbetslivskonto - valt alternativ = 1.')
        .required(
          'Detta fält ska vara ifyllt med belopp om Arbetslivskonto - valt alternativ = 1.',
        ),
      otherwise: Yup.number(),
    }),
    vacationDays: Yup.number().min(25, 'Antalet semesterdagar kan inte vara under 25.').required('Obligatoriskt, information om antal semesterdagar saknas.'),
    otherAdditions: Yup.number('Endast siffror och kommatecken är tillåtna i detta fält.'),
    comment: Yup.string(),
  })
}